import React from 'react';

interface IPillToggleProps {
    checked: boolean;
    title?: string;
    onChange: () => void;
}

// Rounded horizontal pill switch - a real checkbox underneath (kept accessible/functional,
// just visually hidden) driving a sliding thumb rendered on top of it.
const PillToggle = (props: IPillToggleProps) => (
    <label
        style={{ position: 'relative', display: 'inline-block', width: '38px', height: '20px', flexShrink: 0 }}
        title={props.title}
        onClick={(e) => e.stopPropagation()}
        onDoubleClick={(e) => e.stopPropagation()}
    >
        <input
            type="checkbox"
            checked={props.checked}
            onChange={props.onChange}
            style={{ opacity: 0, width: 0, height: 0 }}
        />
        <span
            style={{
                position: 'absolute',
                inset: 0,
                backgroundColor: props.checked ? '#4caf50' : '#ccc',
                borderRadius: '999px',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
            }}
        >
            <span
                style={{
                    position: 'absolute',
                    top: '2px',
                    left: props.checked ? '20px' : '2px',
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.4)',
                    transition: 'left 0.2s ease'
                }}
            />
        </span>
    </label>
);

export default PillToggle;



// WEBPACK FOOTER //
// ./src/components/controls/PillToggle.tsx